export default __webpack_public_path__ + "static/media/Blue spring wreath.dffe5758.jpg";